/** القسم 6 — «التصور المقترح لفورمات برنامج حلول» (ملف PDF العربي). */
export const programFormatAr = {
  id: 'program-format',
  navLabel: 'فورمات البرنامج',
  eyebrow: 'فورمات البرنامج',
  title: 'التصور المقترح لفورمات برنامج «حلول»',
  subtitle:
    'برنامج اقتصادي واستثماري أسبوعي مدة حلقته 60 دقيقة، يقدم رؤية الدولة واقتصادها وفرصها من خلال عشر فقرات مترابطة.',
  blocks: [
    {
      icon: 'badge',
      title: 'اسم البرنامج',
      paragraphs: [
        'حلول — برنامج اقتصادي واستثماري دولي.',
        'وتتغير التسمية المحلية بحسب السوق، مع الحفاظ على الهوية الأساسية الموحدة للبرنامج، مثل:',
      ],
      chips: ['حلول مصر', 'حلول السعودية', 'حلول الإمارات', 'حلول بريطانيا', 'حلول سنغافورة'],
    },
    {
      icon: 'live_tv',
      title: 'طبيعة البرنامج',
      paragraphs: [
        'برنامج اقتصادي واستثماري أسبوعي، مدة الحلقة 60 دقيقة شاملة الفواصل، يقدم رؤية الدولة واقتصادها وفرصها من خلال حوار تلفزيوني حي يجمع بين:',
      ],
      flow: [
        'المسؤولين',
        'المستثمرين',
        'الشركات',
        'المؤسسات المالية',
        'الخبراء',
        'الجمهور الاقتصادي',
        'الضيوف الدوليين',
      ],
      flowJoin: '+',
      stats: [
        { value: '60', label: 'دقيقة مدة الحلقة' },
        { value: '52', label: 'حلقة سنويًا' },
        { value: '1 → 2', label: 'حلقة أسبوعيًا مع اتساع المشروع' },
      ],
      closing: [
        'ولا تقوم الحلقة على حوار واحد طويل، وإنما على مجموعة فقرات مترابطة تتحرك حول ملف اقتصادي أو استثماري رئيسي.',
        'الشكل المقترح: حلقة واحدة أسبوعيًا في المرحلة الأولى — 52 حلقة سنويًا. ومع اتساع نطاق المشروع يمكن الانتقال إلى حلقتين أسبوعيًا.',
      ],
    },
    {
      icon: 'theaters',
      title: 'شكل الاستوديو',
      wide: true,
      paragraphs: [
        'يكون البرنامج داخل استوديو كبير أو مسرح تلفزيوني اقتصادي وليس استوديو حوار تقليديًا. ويتكون من:',
      ],
      labeled: [
        { label: 'المسرح الرئيسي', text: 'المقدم والضيوف الرئيسيون.' },
        { label: 'شاشة البيانات', text: 'خرائط، مؤشرات، مشروعات، رسوم بيانية، صور، عروض بصرية.' },
        { label: 'منطقة الجمهور', text: 'رجال أعمال، مستثمرون، مؤسسات مالية، شركات وخبراء.' },
        { label: 'غرفة الفرص', text: 'مساحة مستقلة أو شبه مستقلة للقاءات المحدودة والمتخصصة.' },
      ],
      closing: 'ويتم تصميم المكان بحيث تسمح الحركة بين هذه المساحات بتغيير الإيقاع البصري للحلقة.',
    },
    {
      type: 'segments',
      icon: 'view_agenda',
      title: 'نموذج الحلقة',
      items: [
        {
          tag: 'الفقرة الأولى',
          name: '«قضية الحلقة»',
          duration: '3 دقائق',
          points: [
            'افتتاحية بصرية سريعة تقدم الدولة أو القطاع أو المشروع الذي تدور حوله الحلقة.',
            'يظهر عنوان الحلقة، وتُطرح القضية الرئيسية: ما الذي نريد أن نعرفه أو نحققه اليوم؟',
          ],
        },
        {
          tag: 'الفقرة الثانية',
          name: '«رؤية الدولة»',
          duration: '7 دقائق',
          points: [
            'مسؤول أو شخصية رئيسية يقدم: الرؤية، الأهداف، الأولويات، المشروعات، الاحتياجات، الفرص.',
            'الحوار مركز ومباشر، وليس مؤتمرًا صحفيًا.',
          ],
        },
        {
          tag: 'الفقرة الثالثة',
          name: '«السوق بالأرقام»',
          duration: '5 دقائق',
          points: [
            'عرض بصري للبيانات الرئيسية: حجم السوق، النمو، الاستثمارات، القطاعات، الفرص، التحديات.',
            'وتُستخدم الخرائط والرسوم المتحركة والذكاء الاصطناعي في عرض المعلومات.',
          ],
        },
        {
          tag: 'الفقرة الرابعة',
          name: '«الفرصة»',
          duration: '6 دقائق',
          points: [
            'تحديد الفرصة بشكل عملي، قد تكون: مشروعًا — قطاعًا — استثمارًا — تمويلًا — تقنية — شراكة — أصلًا — مزادًا.',
            'ويتم توضيح: ما الفرصة؟ وما الذي تحتاجه لكي تتحرك؟',
          ],
        },
        {
          tag: 'الفقرة الخامسة',
          name: '«من يستطيع المشاركة؟»',
          duration: '7 دقائق',
          points: [
            'يدخل طرف من خارج السوق المحلي: مستثمر، بنك، صندوق، شركة، مؤسسة، أو شريك استراتيجي.',
            'ويُطرح السؤال: هل هذه الفرصة تناسبكم؟ وما الذي تحتاجونه للدخول إليها؟',
          ],
        },
        { isBreak: true, name: 'الفاصل', duration: '3 دقائق' },
        {
          tag: 'الفقرة السادسة',
          name: '«الحوار الدولي»',
          duration: '7 دقائق',
          points: [
            'اتصال مباشر أو حضور ضيف من سوق آخر.',
            'ويجري الحوار بين الطرف المحلي والطرف الدولي حول إمكانية التعاون.',
          ],
        },
        {
          tag: 'الفقرة السابعة',
          name: '«مجلس السوق»',
          duration: '6 دقائق',
          points: [
            'ينضم عدد محدود من رجال الأعمال والمستثمرين والخبراء.',
            'وتُطرح عليهم القضية من زوايا متعددة، بحيث يظهر البرنامج كمجلس اقتصادي حي.',
          ],
        },
        {
          tag: 'الفقرة الثامنة',
          name: '«غرفة الفرص»',
          duration: '7 دقائق',
          points: [
            'ينتقل عدد محدود من الأطراف إلى جلسة أكثر تركيزًا، مثلًا: مسؤول + مستثمر + بنك + شركة متخصصة.',
            'ويتم النقاش حول: ماذا نحتاج؟ من يستطيع تقديمه؟ ما العقبات؟ وما الخطوة التالية؟',
            'وقد يستمر اللقاء خارج البث بحسب طبيعة الملف.',
          ],
        },
        {
          tag: 'الفقرة التاسعة',
          name: '«الجسر العالمي»',
          duration: '4 دقائق',
          points: [
            'اتصال قصير مع سوق آخر: كيف يرى السوق الخارجي هذه الفرصة؟',
            'وهنا تظهر العلاقة المباشرة بين برنامج «حلول» والأسواق الأخرى.',
          ],
        },
        {
          tag: 'الفقرة العاشرة',
          name: '«ماذا بعد؟»',
          duration: 'دقيقتان',
          points: [
            'يعود المقدم إلى المسرح الرئيسي ويلخص: ما الذي عرفناه؟ ما الفرصة؟ من تفاعل معها؟ وما الخطوة التالية؟',
          ],
        },
      ],
      signatureLabel: 'وتنتهي الحلقة بجملة ثابتة:',
      signature: 'من الرؤية إلى الفرصة… ومن الفرصة إلى السوق.',
    },
    {
      type: 'table',
      icon: 'schedule',
      title: 'التوزيع الزمني',
      headers: ['الفقرة', 'المدة'],
      rows: [
        ['قضية الحلقة', '3 دقائق'],
        ['رؤية الدولة', '7 دقائق'],
        ['السوق بالأرقام', '5 دقائق'],
        ['الفرصة', '6 دقائق'],
        ['من يستطيع المشاركة؟', '7 دقائق'],
        ['الفاصل', '3 دقائق'],
        ['الحوار الدولي', '7 دقائق'],
        ['مجلس السوق', '6 دقائق'],
        ['غرفة الفرص', '7 دقائق'],
        ['الجسر العالمي', '4 دقائق'],
        ['ماذا بعد؟', 'دقيقتان'],
      ],
      footer: { label: 'المجموع', value: '57 دقيقة' },
      notes: [
        'وتتبقى 3 دقائق مرنة للتتر والانتقالات أو زيادة زمن بعض الفقرات، بحيث يصبح إجمالي الحلقة 60 دقيقة.',
      ],
    },
    {
      icon: 'dashboard_customize',
      title: 'أنواع الحلقات',
      paragraphs: ['مع ثبات الفورمات، يمكن أن تتغير طبيعة الحلقة:'],
      labeled: [
        { label: 'حلقة دولة', text: 'رؤية دولة وفرصها وأسواقها المستهدفة.' },
        { label: 'حلقة قطاع', text: 'العقار، الطاقة، الصناعة، التكنولوجيا، السياحة وغيرها.' },
        { label: 'حلقة مشروع', text: 'مشروع كبير يبحث عن مستثمرين أو شركاء أو تمويل.' },
        { label: 'حلقة فرصة دولية', text: 'فرصة محلية يتم فتحها أمام أسواق أخرى.' },
        {
          label: 'حلقة حلول وشراكات',
          text: 'مشكلة أو احتياج والبحث عن الأطراف القادرة على التعامل معه.',
        },
        { label: 'حلقة متابعة', text: 'علاقة أو فرصة بدأت في حلقة سابقة وتم تطويرها.' },
      ],
    },
    {
      icon: 'smart_toy',
      title: 'دور التكنولوجيا',
      paragraphs: ['يتم استخدام الذكاء الاصطناعي والتقنيات البصرية في:'],
      chips: [
        'الخرائط الاقتصادية',
        'تحليل البيانات',
        'الرسوم التفاعلية',
        'مقارنة الأسواق',
        'عرض المشروعات',
        'بناء نماذج بصرية',
        'الربط المباشر بين الدول',
      ],
      closing: 'بحيث تصبح التكنولوجيا جزءًا من السرد التلفزيوني، وليس مجرد عنصر استعراضي.',
    },
    {
      icon: 'emoji_events',
      title: 'النتيجة',
      wide: true,
      highlight: true,
      paragraphs: ['الفورمات المقترح يجعل كل حلقة تنتج في الوقت نفسه:'],
      flow: [
        'برنامجًا تلفزيونيًا',
        'محتوى رقميًا',
        'نقاشًا اقتصاديًا',
        'علاقات جديدة',
        'فرصًا قابلة للتطوير',
      ],
      flowJoin: '+',
      closing:
        'ويظل الشكل الإخراجي النهائي مفتوحًا للتطوير مع شركة الإنتاج والقناة أو المنصة وفق الإمكانات الفنية والميزانية، مع الحفاظ على الهيكل الأساسي للفورمات.',
    },
  ],
};
